import {
	ActionBar,
	ActionBarItemGroup,
	Button,
	TextIndicator,
} from '@innovyze/stylovyze';
import { useFormikContext } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { editSensorDataPoints } from '@Actions';
import { getValue } from '@Selectors';
import { useGlobalization } from '@Translations/useGlobalization';
import { STATUS_ENUM } from '@Types/editSensorData.types';
import { SensorPointsFormikProps } from '@Types/sensor.types';
import { ACTIONS_STATUS } from './utils/constants';

export default function EditSensorDataTableFooter() {
	const dispatch = useDispatch();
	const { t } = useGlobalization();
	const { values } = useFormikContext<SensorPointsFormikProps>();
	const { status } = useSelector(getValue).editSensorData;
	const { sensorId } = useParams<{ sensorId: string }>();

	const actionObject = ACTIONS_STATUS(t)[status];
	const { icon: Icon, iconColor, text, textColor } = actionObject;

	const disabled =
		!values.points.length ||
		!values.points.filter(point => typeof point.newValue === 'number')
			.length ||
		status === STATUS_ENUM.SUCCESS ||
		status === STATUS_ENUM.PENDING;

	const handleSave = () => {
		const newValues = values.points
			.filter(point => typeof point.newValue === 'number')
			.map(point => ({
				oldValue: point.value.doubleValue,
				newValue: point.newValue as number,
				timeStamp: point.timestamp.timestamp,
				sensorId,
			}));
		dispatch(editSensorDataPoints(newValues));
	};

	return (
		<ActionBar>
			<ActionBarItemGroup />
			<ActionBarItemGroup>
				<ActionBar>
					{status !== 'idle' && (
						<TextIndicator
							icon={<Icon />}
							label={text}
							variant="outlined"
							textColor={textColor}
							iconColor={iconColor}
						/>
					)}
					<Button
						dataCy="saveButton"
						style={{ width: 'fit-content', marginLeft: 'auto' }}
						variant="contained"
						color="primary"
						onClick={handleSave}
						disabled={disabled}>
						{t('Save')}
					</Button>
				</ActionBar>
			</ActionBarItemGroup>
		</ActionBar>
	);
}
